import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["policy", "prerequisites"]

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.policyTargets.find((radio) => radio.checked)
    const restricted = selected?.value === "restricted"
    this.prerequisitesTarget.hidden = !restricted
  }
}
